import Vue from "vue";
import BootstrapVue from "bootstrap-vue/dist/bootstrap-vue.esm";
import App from "./App.vue";
import Axios from "axios";
import VuePageTransition from "vue-page-transition";
import VueAnalytics from "vue-analytics";
import VueMeta from "vue-meta";
import VueDrift from 'vue-drift'

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import router from "./router";
import store from "./store";
import AOS from "aos";
import "aos/dist/aos.css";

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: "UA-131120430-2",
  router,
});
Vue.use(VueDrift, {
  appId: 'bw8fp6cvdg9x',
})
Vue.use(VueMeta);
Vue.use(VuePageTransition);
Vue.use(BootstrapVue);
Vue.prototype.$http = Axios;
Vue.config.productionTip = false;

new Vue({
  created() {
    AOS.init();
  },
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
